// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/media/hero.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/media/hero-mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  position: relative;
}

.hero__container {
  height: 720px;
  position: relative;
}

.hero__caption {
  max-width: 630px;
  position: absolute;
  top: 286px;
  left: 20px;
  right: 20px;
}

.hero__title {
  color: var(--white, #FFF);
  font-size: 48px;
  font-weight: 500;
  line-height: 56px;
  margin-bottom: 8px;
}

.hero__description {
  padding: 8px 16px;
  border-radius: 16px;
  background: #FF0009;
  color: #FFFFFF;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 48px;
}

.hero__amount {
  color: #FFFFFF;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #FF0009;
  font-size: 96px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.hero__amount span:first-child {
  font-family: Freshman, serif !important;
}

.hero__amount span:last-child {
  color: var(--white, #FFF);
  font-family: Arial, serif;
  font-size: 96px;
  font-style: normal;
  font-weight: 400;
  line-height: 96px;
}

.hero__link {
  padding: 16px 28px;
  border-radius: 8px;
  background-color: #FF0009;
  color: #FFFFFF;
  display: inline-block;
}

.hero__link:hover {
  color: #FFFFFF;
}

.hero__scroll {
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 64px;
  display: flex;
  align-items: center;
}

.hero__scroll-text {
  color: #FFFFFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.hero__gradient {
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  background: linear-gradient(0deg, #000 -11.65%, rgba(0, 0, 0, 0) 100%);
  pointer-events: none;
}

@media only screen and (max-width: 767px) {
  .hero {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  .hero__caption {
    top: 152px;
    max-width: 335px;
  }
  .hero__title {
    font-size: 28px;
    line-height: 32px;
    padding-inline: 12px;
  }
  .hero__description {
    padding: 6px 12px;
    font-size: 28px;
    line-height: 32px;
    border-radius: 12px;
    margin-bottom: 32px;
  }
  .hero__amount {
    font-size: 56px;
  }
  .hero__amount span:last-child {
    font-size: 56px;
    line-height: 56px;
  }
  .hero__scroll {
    bottom: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/hero/Hero.scss","webpack://./src/modules/home/components/hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yDAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;ACCpB;;ADCE;EACE,aAAa;EACb,kBAAkB;ACEtB;;ADCE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;ACEf;;ADCE;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;ACEtB;;ADCE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EAEjB,uBAAmB;EACpB,kBAAA;ECED,mBAAmB;ADAnB;;ACGF;EDAI,cAAA;EACA,8BAAe;EACf,kCAAkB;EAClB,eAAa;EACb,kBAAa;EACb,gBAAa;EACb,mBAAQ;ECIV,aAAa;EDbZ,QAAA;EAaG,mBAAa;ACGnB;;ADhBG;EAgBG,uCAAyB;ACI/B;;AAEA;EDFM,yBAAgB;EAChB,yBAAiB;EAClB,eAAA;ECIH,kBAAkB;EDDlB,gBAAQ;EACN,iBAAS;ACGb;;AAEA;EDDI,kBAAS;EAKV,kBAAA;ECDD,yBAAyB;EDTxB,cAAM;EAQH,qBAAc;ACIpB;;ADAE;EACE,cAAU;ACGd;;AAEA;EDDI,kBAAa;EACb,UAAA;EASD,QAAA;ECLD,YAAY;EDAR,aAAW;EAGX,mBAAmB;ACIzB;;ADAE;EACE,cAAW;EACX,eAAa;EACb,kBAAkB;EAClB,gBAAS;EACT,mBAAY;ACGhB;;AAEA;EDAA,WAAY;EACV,aAAM;ECEN,kBDDkB;ECElB,SD+BC;EC7BD,sEDDc;ECEd,oBDDoB;ACEtB;;AAEA;EACE;IDCI,yDAAoB;ECCxB;EDEE;IACE,UAAS;IACT,gBAAe;ECAnB;EACA;IDEI,eAAe;IAChB,iBAAA;IAED,oBAAU;ECDZ;EACA;IDAG,iBAGK;IACF,eAAe;IACf,iBAAiB;IAClB,mBAAA;IAGH,mBAAU;ECHZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".hero {\n  width: 100%;\n  background-image: url(\"/public/media/hero.png\");\n  background-size: cover;\n  background-position: center;\n  position: relative;\n\n  &__container {\n    height: 720px;\n    position: relative;\n  }\n\n  &__caption {\n    max-width: 630px;\n    position: absolute;\n    top: 286px;\n    left: 20px;\n    right: 20px;\n  }\n\n  &__title {\n    color: var(--white, #FFF);\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 56px;\n    margin-bottom: 8px;\n  }\n\n  &__description {\n    padding: 8px 16px;\n    border-radius: 16px;\n    background: #FF0009;\n    color: #FFFFFF;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 56px;\n    width: fit-content;\n    margin-bottom: 48px;\n  }\n\n  &__amount {\n    color: #FFFFFF;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #FF0009;\n    font-size: 96px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    display: flex;\n    gap: 8px;\n    margin-bottom: 24px;\n\n    span:first-child {\n      font-family: Freshman, serif !important;\n    }\n    span:last-child {\n      color: var(--white, #FFF);\n      font-family: Arial, serif;\n      font-size: 96px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 96px;\n    }\n  }\n\n  &__link {\n    padding: 16px 28px;\n    border-radius: 8px;\n    background-color: #FF0009;\n    color: #FFFFFF;\n    display: inline-block;\n\n    &:hover {\n      color: #FFFFFF;\n    }\n  }\n\n  &__scroll {\n    position: absolute;\n    z-index: 1;\n    right: 0;\n    bottom: 64px;\n    display: flex;\n    align-items: center;\n\n    &-text {\n      color: #FFFFFF;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  &__gradient {\n    width: 100%;\n    height: 100px;\n    position: absolute;\n    bottom: 0;\n    background: linear-gradient(0deg, #000 -11.65%, rgba(0, 0, 0, 0.00) 100%);\n    pointer-events: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .hero {\n    background-image: url(\"/public/media/hero-mobile.png\");\n\n    &__caption {\n      top: 152px;\n      max-width: 335px;\n    }\n\n    &__title {\n      font-size: 28px;\n      line-height: 32px;\n      padding-inline: 12px;\n    }\n\n    &__description {\n      padding: 6px 12px;\n      font-size: 28px;\n      line-height: 32px;\n      border-radius: 12px;\n      margin-bottom: 32px;\n    }\n\n    &__amount {\n      font-size: 56px;\n\n      span:last-child {\n        font-size: 56px;\n        line-height: 56px;\n      }\n    }\n\n    &__scroll {\n      bottom: 12px;\n    }\n  }\n}",".hero {\n  width: 100%;\n  background-image: url(\"/public/media/hero.png\");\n  background-size: cover;\n  background-position: center;\n  position: relative;\n}\n\n.hero__container {\n  height: 720px;\n  position: relative;\n}\n\n.hero__caption {\n  max-width: 630px;\n  position: absolute;\n  top: 286px;\n  left: 20px;\n  right: 20px;\n}\n\n.hero__title {\n  color: var(--white, #FFF);\n  font-size: 48px;\n  font-weight: 500;\n  line-height: 56px;\n  margin-bottom: 8px;\n}\n\n.hero__description {\n  padding: 8px 16px;\n  border-radius: 16px;\n  background: #FF0009;\n  color: #FFFFFF;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 56px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-bottom: 48px;\n}\n\n.hero__amount {\n  color: #FFFFFF;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #FF0009;\n  font-size: 96px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.hero__amount span:first-child {\n  font-family: Freshman, serif !important;\n}\n\n.hero__amount span:last-child {\n  color: var(--white, #FFF);\n  font-family: Arial, serif;\n  font-size: 96px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 96px;\n}\n\n.hero__link {\n  padding: 16px 28px;\n  border-radius: 8px;\n  background-color: #FF0009;\n  color: #FFFFFF;\n  display: inline-block;\n}\n\n.hero__link:hover {\n  color: #FFFFFF;\n}\n\n.hero__scroll {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  bottom: 64px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.hero__scroll-text {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.hero__gradient {\n  width: 100%;\n  height: 100px;\n  position: absolute;\n  bottom: 0;\n  background: -webkit-gradient(linear, left bottom, left top, color-stop(-11.65%, #000), to(rgba(0, 0, 0, 0)));\n  background: linear-gradient(0deg, #000 -11.65%, rgba(0, 0, 0, 0) 100%);\n  pointer-events: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .hero {\n    background-image: url(\"/public/media/hero-mobile.png\");\n  }\n  .hero__caption {\n    top: 152px;\n    max-width: 335px;\n  }\n  .hero__title {\n    font-size: 28px;\n    line-height: 32px;\n    padding-inline: 12px;\n  }\n  .hero__description {\n    padding: 6px 12px;\n    font-size: 28px;\n    line-height: 32px;\n    border-radius: 12px;\n    margin-bottom: 32px;\n  }\n  .hero__amount {\n    font-size: 56px;\n  }\n  .hero__amount span:last-child {\n    font-size: 56px;\n    line-height: 56px;\n  }\n  .hero__scroll {\n    bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
